import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, inject, Injectable, Injector } from "@angular/core";
import { ToastrService } from "ngx-toastr";

import { environment } from "../../environments/environment";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly injector = inject(Injector);

    public handleError(error: Error | HttpErrorResponse | any) {
        const toastr = this.injector.get(ToastrService);

        let message = error.message;
        if (error?.code && typeof error.code === "string" && error.code.startsWith("auth/")) {
            message = null;
        } else if (environment.production) {
            message = "handler.prod_message";
        }

        if (message) {
            toastr.error(message);
            throw error;
        }
    }
}
